export default __webpack_public_path__ + "mini-icon-ios-16@2x.png";